import { useEffect, useState } from 'react';
import type {
  ExtensionBridge,
  ExtensionCapability,
} from '@doxyme/extensions-bridge';

/**
 * Utility hook to use a Capability as a React state component. Does not add/remove capability to the bridge!!
 * @param bridge - bridge instance
 * @param capabilityId  - capability id
 * @returns Capability instance or undefined.
 * @example
 * ```tsx
 * const callFrameApplet = useCapability<CallFrameAppletCapability>(bridge, CallFrameAppletCapability.id);
 * ```
 */
export function useCapability<T extends ExtensionCapability | undefined>(
  bridge: ExtensionBridge,
  capabilityId: ExtensionCapability['id'],
): T | undefined {
  const [capability, setCapability] = useState<T | undefined>(
    bridge.getCapability(capabilityId),
  );

  useEffect(() => {
    return bridge.onCapabilityChange(() => {
      setCapability(bridge.getCapability(capabilityId));
    });
  }, []);

  return capability;
}
